import { useMutation } from "@tanstack/react-query";
import { PostContactRecordParams } from "../types/types";
import { postContactRecord } from "../api/mobility";
import { useSnackbar } from "notistack";

interface Params extends PostContactRecordParams {
  showNokNum: () => void;
  showNum: () => void;
  closeModal: () => void;
}

const usePostContactRecord = ({
  admin_idx,
  mobility_seq,
  phone,
  reader_name,
  who,
  name,
  // showNokNum,
  showNum,
  closeModal,
}: Params) => {
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation({
    mutationFn: () =>
      postContactRecord({
        admin_idx,
        mobility_seq,
        phone,
        reader_name,
        who,
        name,
      }),

    onSuccess: () => {
      showNum();
      // if (who === 1) {
      //   showNum();
      // } else {
      //   showNokNum();
      // }
      closeModal();
    },
    onError: () => {
      enqueueSnackbar(
        `연락처를 열람할 수 없습니다. 잠시 후에 다시 시도해 주세요.`,
        {
          variant: "error",
        }
      );
    },
  });
  return mutation;
};

export default usePostContactRecord;
